class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.updateFreeShippingMessage();
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('no-NO', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
  }

  updateFreeShippingMessage() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const cartTotal = cart.total_price; // Get total price in cents
            console.log("Cart Total (from API):", cartTotal);

            const freeShippingElement = document.querySelector('.cart-shipping__cart-notification');
            if (!freeShippingElement) return;

            const freeShippingLimit = 30000; // 300 NOK in cents (over 299 NOK)
            const remainingAmount = freeShippingLimit - cartTotal;

            console.log("Remaining Amount:", remainingAmount);

    if (remainingAmount > 0) {
        freeShippingElement.innerHTML = `Du har <b>${this.formatMoney(remainingAmount)}</b> igjen til gratis frakt`;
    } else {
        freeShippingElement.innerHTML = `Gratulerer! Du har <b>gratis frakt</b> 🎉`;
    }
        })
        .catch(error => console.error("Error fetching cart:", error));
    


}

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

     this.updateFreeShippingMessage();

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
